angular.module('iqxCore')
.controller('ActionDialogLegacyCtrl', function ($scope, FormSvc, ActionDialogLegacySvc, $timeout, LanguageSvc, ApiSvc, ApplicationSvc, $q) {

	$scope.selects={}
	$scope.selects.classcode=[]
	$scope.selects.outcome=[]
	$scope.selects.contacts=[]
	$scope.selects.acceptDeclineReason=[]
	$scope.theRecord={}
	$scope.callback={}

	$scope.ActionDialog=ActionDialogLegacySvc.ActionOpts

	$scope.getFavouriteStatus=function(){
		return ApiSvc.fetch($scope,{fetchAPI:'callresult/NetOwnerIsFav?pLinkID='+$scope.ActionDialog.obj.linkID, fetchTarget:'isFav',multiRow:false})
		.then(function(){
			if ($scope.isFav.favid) {
				$scope.FavIcon='glyphicon-star'
				$scope.FavText=LanguageSvc.lang.ActionDialog.favourites.remove
			} else {
				$scope.FavIcon='glyphicon-star-empty'
				$scope.FavText=LanguageSvc.lang.ActionDialog.favourites.add
			}
		})
	}

	$scope.FavouritesToggle=function(){
		var data={}
		return ApiSvc.fetch($scope,{fetchAPI:'callresult/NetOwnerGetFavTitles',fetchTarget:'FavHeadings',multiRow:true})
		.then(function(){
			FormSvc.modalForm($scope,'manageFavourites',data,'md',{label:'col-sm-3', data:'col-sm-7'},$scope.tags)
			.then(function(data){
				$scope.FavHeadings=[]
				if (data.manageFavs) { // we are dealing with adding something to the favs
					var type
					switch($scope.ActionDialog.obj.type){
						case 'Company':
							type="C"
						break
						case 'Contacts':
							type="E"
						break
						case 'Person':
							type="P"
						break
					}

					return ApiSvc.fetch($scope,{
						fetchAPI:'call/NetOwnerAddToFavs?pParent='+data.manageFavs+'&pLinkID='+$scope.ActionDialog.obj.linkID+'&pType='+type,
						fetchTarget:'addToFavs',
						multiRow:false
					})
					.then(function(){
						$scope.successMessage=$scope.ActionDialog.obj.title + " was added to your favourites successfully."
					})
					.then(function(){
						 return $timeout(function() {
						 	$scope.successMessage=undefined
						 }, 3000)
					})
				}

				if (data.removeFavs && data.removeFavs == 'y') { // we are deleting from the favs! - but make sure they said yes!
				    var args=args || {}
				    return ApiSvc.fetch($scope,{fetchAPI:'call/NetOwnerRemoveFromFavs?FavID='+$scope.isFav.favid,fetchTarget:'removedFromFavs',multiRow:false})
					.then(function(){
						$scope.successMessage=$scope.ActionDialog.obj.title + " was removed from your favourites successfully."
					})
					.then(function(){
						 return $timeout(function() {
						 	$scope.successMessage=undefined
						 }, 3000)
					})
				}
			})
		})
	}

	$scope.makeAppointment=function(){
		if ($scope.ActionDialog.obj.type=="Company") {
			$scope.fetch({
				fetchAPI:'callresult/NetOwnerContactList?pCompanyID='+$scope.ActionDialog.obj.linkID,
	      		fetchTarget:'companyContacts',
	      		multiRow:true
	      	})
		}

		var obj=$scope.ActionDialog.obj
		$scope.xCaption="Appointment for " + obj.title
		var data={
		  xNew:true,
		  xType:$scope.theRecord.xType,
		  xPopupMinutes:0
		}
		var newData={}
		FormSvc.modalForm($scope,'diaryAppt',data,'md',{label:'col-sm-3', data:'col-sm-7'},$scope.tags)
		.then(function(data){
			newData.pAction='N'
			newData.pDescription=data.xDescription
			newData.pStartDate=moment(data.xDateFrom).format('DD/MM/YYYY')
			newData.pStartTime=moment(data.xTimeFrom).format('HH:mm')

		    if (data.xPopupMinutes!=0 && data.xPopupMinutes_checkbox) {
		      newData.pMinutesBefore=data.xPopupMinutes
		    }

			if(data.xType=='Appointment'){
				newData.pEndDate=moment(data.xDateTo).format('DD/MM/YYYY')
				newData.pEndTime=moment(data.xTimeTo).format('HH:mm')
			}

			if(data.xNotes){
			  newData.pNotes=data.xNotes
			}

			if(obj.type=="Person"){
			  newData.pPersonID=obj.linkID
			} else {
				newData.pEmploymentID=$scope.selects.contacts.Value
			}

			return $scope.exec('call/NetOwnerDiarySet',newData)
		})
		.then(function(returnVal){
			if (returnVal) {
				$scope.successMessage=LanguageSvc.lang.ActionDialog.createAppointment.successMessage
			}
		})
		.then(function(){
			 return $timeout(function() {
			 	$scope.successMessage=undefined
			 }, 3000)
		})
		.catch(function (err) {
			if (err && err!="escape key press") {ApplicationSvc.showMessage('Error',err,true)}
		})
	}

	$scope.isEmpty=function(obj){
		for(var key in obj){
	        if(obj.hasOwnProperty(key)){
	            return false
	        }
		}
		return true
	}

	$scope.validateSelect=function($select){
		if ($select.length == 0) {
			return false
		} else {
			return $select
		}
	}

	$scope.outcomeChanged=function($item){
		if (!$item.callback) {
			$item.callback=0
		}
		$scope.callback.date=moment().add($item.callback, 'days').toDate()
		$scope.callback.time=angular.copy($scope.callback.date)
	}

	$scope.getContactEvents=function(){
		$scope.contactEvents = ActionDialogLegacySvc.Actions($scope, 'contactevents', '50', $scope.ActionDialog.obj)
	}

	$scope.getContactDetails=function(){
		$scope.contactEvents = ActionDialogLegacySvc.Actions($scope, 'getcontactdetails', '50', $scope.ActionDialog.obj)
	}

    $scope.viewDocuments=function(){
        $scope.candidateDocuments = ActionDialogLegacySvc.Actions($scope, 'candidateDocuments', '50', $scope.ActionDialog.obj)
    }

    $scope.firstReasonChanged=function($item){
    	if ($scope.selects.acceptDeclineReason.IsFinal=='1') {
    		$scope.isFinal=true
			return ApiSvc.fetch(
				$scope,
				{
					fetchAPI:'callresult/NetClientRejectCandidateReason',
					fetchTarget:'finalReason',
					multiRow:true
				}
			)
    	} else {
    		$scope.isFinal=false
    	}
    }

    $scope.AcceptOrDecline=function(status){
    	if ($scope.selects.acceptDeclineReason.IsFinal!='1') {
    		$scope.selects.finalReason={}
    	}

        var newData={
        	'pVacancyID': $scope.activeRequirement.RowID,
        	'pPersonID': $scope.ActionDialog.obj.linkID,
        	'pStatusReasonID': $scope.selects.acceptDeclineReason.value,
        	'pRejectionReasonID': ($scope.selects.finalReason.value||undefined)
        }

        if (newData.pStatusReasonID===undefined || newData.pStatusReasonID=='') {
        	FormSvc.alert("Error", "You need to select something before clicking submit.", "error")
        	return false
        }

        if (newData.pRejectionReasonID===undefined && $scope.selects.acceptDeclineReason.IsFinal=='1') {
        	FormSvc.alert("Error", "You must have a reason for rejecting them.", "error")
        	return false
        }

		return $scope.exec('call/NetClientVacanciesShortlistAction',newData)
		.then(function(rtrn){
			if (rtrn) {
				FormSvc.alert("Actioned!", "The candidate has been updated.", "info")
				$scope.ShortlitedAcceptOrDecline=false
			} else {
				FormSvc.alert("Error", "There was an error updating this candidate.", "error")
			}
		})
    }

    $scope.getReasons=function(){
		return ApiSvc.fetch(
			$scope,
			{
				fetchAPI:'callresult/NetClientCandidateStatusUpdate',
				fetchTarget:'AcceptDeclineReasons',
				multiRow:true
			}
		)
    }

    $scope.viewProgressHistory=function(){
			var StartDate = moment().subtract(6, 'month').toDate()
			var EndDate = moment().toDate()
			return ApiSvc.fetch(
				$scope,
				{
					fetchAPI:'callresult/NetClientVacanciesCandidateHistory?pPersonID='+$scope.ActionDialog.obj.linkID+'&pCompanyID='+$scope.ActionDialog.obj.companyID+'&pFilterStartDate='+moment(StartDate).toISOString()+'&pFilterEndDate='+moment(EndDate).toISOString(),
					fetchTarget:'personHistory',
					dateFields: ['HistoryDate'],
					multiRow:true
				}
			)
			.then(function(){
				var choices=[{desc:'Close',type:'primary',code:''}]
				var data={choices:choices}

				FormSvc.modalInfo($scope,'progressHistory',data, 'lg')
			})
    }

    if ($scope.userClass()=='OWNER') { // only do this if we are logged in as a consultant as favs aren't available to anyone else.
        $scope.getFavouriteStatus() // On Action Dialogue Launch
    }

    if ($scope.ShortlitedAcceptOrDecline==true) {
    	$scope.getReasons()
    }
})
